"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addMemoryWarningListener = void 0;
const addMemoryWarningListener = _mmkv => {
  //no-op function, there is not a web equivalent to memory warning
};
exports.addMemoryWarningListener = addMemoryWarningListener;
//# sourceMappingURL=MemoryWarningListener.web.js.map